import OrbitApiV1 from '.'

class AdminAPI {
  static createMsisdnTags(tags, headers = {}) {
    return OrbitApiV1.httpPost(`/admin/msisdnTags`, headers, tags)
  }

  static uploadSims(uploadObject, headers = {}) {
    return OrbitApiV1.httpPost(`/admin/uploadSims`, headers, uploadObject)
  }

  static uploadIccid(uploadList, headers = {}) {
    return OrbitApiV1.httpPost(`/admin/iccid`, headers, uploadList)
  }

  static uploadMsisdn(uploadList, headers = {}) {
    return OrbitApiV1.httpPost(`/admin/msisdn`, headers, uploadList)
  }
}

export default AdminAPI
